import { useTranslation } from "react-i18next";

import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const ChildrenPredictionMissingState = () => {
  const { t } = useTranslation();

  return (
    <Stack justify={"center"} gap="0">
      <Text fz="xs" c="red">
        {t("qrl.prediction.missing.title")}
      </Text>
      <Text fz="xs" c="dimmed">
        {t("qrl.prediction.missing.subtitle")}
      </Text>
    </Stack>
  );
};
